/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import * as api from "./restApi";
import * as t from "./datasources.generated.types";

function enc(s: any): string { return encodeURIComponent("" + s); }

export interface IDatasources {
    /** Gets all details for single datasource */
    getDatasourceDetails(req: t.IGetDatasourceDetailsReq): Promise<t.IGetDatasourceDetailsRes>;

    /** Gets data for single datasource */
    getSingleDatasource(req: t.IGetSingleDatasourceReq): Promise<t.IGetSingleDatasourceRes>;

    /** Gets datasources that match given criteria */
    searchDatasources(req: t.ISearchDatasourcesReq): Promise<t.ISearchDatasourcesRes>;

    /** Inserts new datasource */
    insertDatasource(req: t.IInsertDatasourceReq): Promise<t.IInsertDatasourceRes>;

}

export class Datasources implements IDatasources {

    client: api.ApiClient;

    constructor(client: api.ApiClient) { this.client = client; }

    /** Gets all details for single datasource */
    async getDatasourceDetails(req: t.IGetDatasourceDetailsReq): Promise<t.IGetDatasourceDetailsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/datasources/${enc(req.id)}/details`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Gets data for single datasource */
    async getSingleDatasource(req: t.IGetSingleDatasourceReq): Promise<t.IGetSingleDatasourceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/datasources/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.get(url, reqx)).data;
    }

    /** Gets datasources that match given criteria */
    async searchDatasources(req: t.ISearchDatasourcesReq): Promise<t.ISearchDatasourcesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/datasources`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Inserts new datasource */
    async insertDatasource(req: t.IInsertDatasourceReq): Promise<t.IInsertDatasourceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/datasources`;
        return (await this.client.post(url, reqx)).data;
    }

}
